module.exports = "<h3>C'est un référentiel personnalisé .....</h3>"